import React, { Component } from 'react';
import { array, func, string, bool, object, oneOfType } from 'prop-types';
import classnames from 'classnames';
import isEqual from 'lodash/isEqual';

import RadioButton from '@components/inputs/RadioButton/RadioButton';
import CheckBox from '@components/inputs/CheckBox/CheckBox';
import Dropdown from '@components/inputs/Dropdown/Dropdown';

import styles from './InputGroup.css';

class InputGroup extends Component {
  static propTypes = {
    groupName: string,
    group: oneOfType([array, object]),
    onOptionPick: func,
    setFirstOption: bool,
    isFirst: bool,
  }

  static defaultProps = {
    setFirstOption: true
  }

  state = {
    selectedOption: null
  }

  optionGroups = [];

  componentDidMount = () => {
    const { setFirstOption } = this.props;

    if (setFirstOption) {
      const firstOption = this.optionGroups[0].options[0];
      const isCheckedCeckbox = firstOption.type === 'checkbox' && firstOption.checked;

      if (firstOption.type === 'radio' || isCheckedCeckbox) {
        this.handleInputCallBack(firstOption);
      } else if (firstOption.type === 'dropdown') {
        this.handleInputCallBack(firstOption.selectList[0]);
      }
    }
  }

  handleInputCallBack = (selectedOption, isChecked) => {
    const { onOptionPick } = this.props;
    
    if (selectedOption.type === 'checkbox' && isChecked !== undefined) {      
      selectedOption.options[selectedOption.value] = isChecked;
      selectedOption.checked = isChecked;
    }

    this.setState({ selectedOption: selectedOption });
    onOptionPick && onOptionPick(selectedOption);
  }

  handleDropdownChange = option => {
    const { onOptionPick } = this.props;

    onOptionPick && onOptionPick(option);
  }

  renderInput = (option, i) => {
    const { groupName } = this.props;
    const { selectedOption } = this.state;

    const isSelectedOption = isEqual(option, selectedOption);

    switch (option.type) {
      case 'checkbox':
        return <CheckBox
          data-input={option.type}
          name={groupName}
          label={option.label}
          onClick={this.handleInputCallBack.bind(null, option)}
          key={`input-${i}`}
          isChecked={option.checked}
          disabled={this.hasOnlyOneOption}
        />;

      case 'radio':
        return <RadioButton
          data-input={option.type}
          name={groupName}
          isChecked={isSelectedOption}
          label={option.label}
          onClick={this.handleInputCallBack.bind(null, option)}
          key={`input-${i}`}
          disabled={this.hasOnlyOneOption}
        />;

      case 'radio-dropdown':
        return <RadioButton
          data-input={option.type}
          withDropdown
          name={groupName}
          isChecked={isSelectedOption}
          label={option.label}
          dropdownOptions={option.selectList}
          onClick={this.handleInputCallBack.bind(null, option)}
          onChange={this.handleDropdownChange}
          key={`input-${i}`}
          disabled={this.hasOnlyOneOption}
        />;

      case 'dropdown':
        return <Dropdown
          opts={option.selectList}
          className={styles.dropdown}
          onChange={this.handleDropdownChange}
          key={`input-${i}`}
        />;
    }
  }

  renderSubgroup = (subgroup, subgroupIndex) => {
    const { isFirst } = this.props;
    const isSubgroup = subgroupIndex > 0;

    const labelClasses = classnames(
      'copy',
      styles.groupLabel,
      {
        'black': isFirst && !isSubgroup,
        'subGroupLabel' : isSubgroup
      },
    );

    return (
      <div className={styles.inputsGroup} key={`subgroup-${subgroupIndex}`}>
        <p className={labelClasses}>{subgroup.label}</p>
        <div className={classnames(styles.inputsWrapper, 'flex flex-align-center')}>
          { subgroup.options.map((option, i) => this.renderInput(option, i))}
        </div>
      </div>
    );
  }

  render() {
    const { group } = this.props;
    this.hasOnlyOneOption = group.length === 1;
    this.optionGroups = group instanceof Array ? group : [ group ];

    return (
      <form className={classnames(styles.form, 'flex flex-align-center')}>
        { this.optionGroups.map((subgroup, i) => this.renderSubgroup(subgroup, i)) }
      </form>
    );
  }
}

export default InputGroup;



// WEBPACK FOOTER //
// ./src/components/ShowCase/Controls/InputGroup/InputGroup.js